export default __webpack_public_path__ + "static/tour_08_student_responses-292b918c2172817ef1b98e61f849a801.jpg";